class EInputValidation {   

    private thereIsNoValue(value: any) {
        return ( value === '' || value === null || value === undefined || typeof value === undefined );
    }

    /**
     * 
     * Validates that the field has a value that is not empty
     * 
     * @param {HTMLElement} el - DOM element to validate if has an empty value
     * 
     */
    public validateRequired(value: any) {
        if ( value === '' ) {
            return { 'message': '' };
        }

        return false;

    }

    public integer(value: any) {
        const isANumber = !isNaN(Number(value)) && Number.isInteger(Number(value));
        const hasDecimal = typeof value === 'string' && value.indexOf('.') >= 0;

        if ( !isANumber || hasDecimal) {
            return { 'message': 'Value must be a whole number' };
        }

        if (Number(value) < 0) {
            return { 'message': 'Value must be positive'};
        }
        return isANumber;

        // this.addToOrRemoveFromErrorArrays(el, isANumber, 'validation', 'Value must be an integer');

    }

    public negative(value:any) {
        const isANumber = !isNaN(Number(value)) && Number.isInteger(Number(value));
        const hasDecimal = typeof value === 'string' && value.indexOf('.') >= 0;

        if ( !isANumber || hasDecimal) {
            return { 'message': 'Value must be a whole number' };
        }

        return isANumber && !hasDecimal;
    }

    public decimal(value: any) {
        const isANumber = Number.isFinite(Number(value));
        if ( !isANumber) {
            return { 'message': 'Value must be a number' };
        }

        
        if (Number(value) < 0) {
            return { 'message': 'Value must be positive'};
        }

        return isANumber;
    }

    public decimalnegative(value: any) {
        const isANumber = Number.isFinite(Number(value));
        if ( !isANumber) {
            return { 'message': 'Value must be a number' };
        }
        return isANumber;
    }

    public string(value: any) {

        if ( this.thereIsNoValue(value) ) {
            return true;
        }

        const stringRegex: any = new RegExp(/[0-9]/gm);
        const result: boolean = !stringRegex.test(value);

        if ( !result ) {
            return { 'message': 'Value must be a string' };
        }

        return result;
    }

    public email(value: any) {

        if ( this.thereIsNoValue(value) ) {
            return true;
        }

        const email = value;
        const emailRegex: any = /.+@.+\..+/;
        const result: boolean = emailRegex.test(email);
        
        if ( !result ) {
            return { 'message': 'The value entered is not a valid email' };
        }

        return result;
    }

    public phone(value: any) {

        if ( this.thereIsNoValue(value) ) {
            return true;
        }

        const phone = value;
        const isNumber: boolean = !isNaN(Number(phone));
        if ( isNumber ) {
            if ( phone.length < 10 || phone.length > 11 ) {
                return { 'message': 'The value is not a valid phone number' };
            }
        } else if ( !isNumber ) {
            const symbolRegex: any = new RegExp(/^\(([0-9]{3})\) ([0-9]{3})[-. ]([0-9]{4})$/);
            const hasSymbols: boolean = symbolRegex.test(phone);

            if ( !hasSymbols ) {
                return { 'message': 'The value is not a valid phone number' };
            }
        }

        return true;
    }

    public range(val: number, min: number, max: number) {
        if ( this.thereIsNoValue(val) ) {
            return true;
        }

        if ( isNaN(val) ) {
            return { 'message': 'Value must be a number' };
        }
        if ( min !== undefined && Number(val) < min ) {
            return { 'message': 'The value can not be less than ' + min };
        }
        if ( max !== undefined && Number(val) > max ) {
            return { 'message': 'The value can not be higher than ' + max };
        }
        
        return true;
    }

}

export default EInputValidation;


// WEBPACK FOOTER //
// ./src/Components/EInput/EInputValidation.tsx